import React from 'react'
import Browse from '../component/Browse'

const NewAndPopu = () => {
  return (
    <div>
      <Browse path="new"/>
    </div>
  )
}

export default NewAndPopu